import { render, staticRenderFns } from "./notice-formula-detail.html?vue&type=template&id=623cfb88&scoped=true&external"
import script from "./notice-formula-detail.js?vue&type=script&lang=js&external"
export * from "./notice-formula-detail.js?vue&type=script&lang=js&external"
import style0 from "./notice-formula-detail.scss?vue&type=style&index=0&id=623cfb88&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623cfb88",
  null
  
)

export default component.exports